import { render, staticRenderFns } from "./FunSettings.vue?vue&type=template&id=0396bbde&"
import script from "./FunSettings.vue?vue&type=script&lang=js&"
export * from "./FunSettings.vue?vue&type=script&lang=js&"
import style0 from "./FunSettings.vue?vue&type=style&index=0&id=0396bbde&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports